import { gql, useQuery } from '@apollo/client'
import { getNodes } from 'resources'
import { pipe, map, prepend } from 'ramda'

export const useSubjects = (discipline) => {
  const { data, loading } = useQuery(SUBJECTS_QUERY, {
    variables: { filter: { disciplineSlug: discipline } },
  })
  return {
    subjects: toOptions(data),
    loading,
  }
}

const SUBJECTS_QUERY = gql`
  query GetSubjects($filter:FilterSubjectsInput!){
    subjects (filter: $filter){
     nodes {
       id
       slug
       name
      }
    }
  }
`

const toOption = ({
  slug: value,
  name: label,
  id,
}) => ({ label, value, id })

const toOptions = pipe(
  getNodes('subjects'),
  map(toOption),
  prepend({
    label: 'Todas',
    value: '',
    id: '',
  })
)
